import get_user_settings_api_call from '../api/settings/user-settings-api-call';
import store from '../../store/store';
import { setAppLanguage } from '../../store/reducers/appSlice';
import { normaliseLanguage } from './languages';

/**
 * Applies the language saved under Settings > General (user settings
 * `language_code`). App init only knows the profile/browser language, so this
 * runs once the session is initialised to reconcile with the stored choice.
 * Leaves the current language alone when no preference is stored.
 *
 * User settings are read with the seller token. Without one (a signed-out
 * visitor, whose tokenless app init also succeeds) there is nothing to read,
 * and asking anyway only earns a 401.
 */
export async function syncLanguageFromUserSettings(): Promise<void> {
  if (!store.getState().auth?.authorization?.accessToken?.sellerToken) {
    return;
  }
  try {
    const settings = await get_user_settings_api_call();
    if (settings?.language_code) {
      store.dispatch(setAppLanguage(normaliseLanguage(settings.language_code)));
    }
  } catch {
    // keep the current language when settings can't be read
  }
}
